import { render } from "./EventWebpageEditPane.vue?vue&type=template&id=7b272409&scoped=true&ts=true"
import script from "./EventWebpageEditPane.vue?vue&type=script&lang=ts"
export * from "./EventWebpageEditPane.vue?vue&type=script&lang=ts"

import "./EventWebpageEditPane.vue?vue&type=style&index=0&id=7b272409&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b272409"]])

export default __exports__